export default "__VITE_ASSET__joju1CK0__";